// extracted by mini-css-extract-plugin
module.exports = {"root":"_aaf11d","logoContainer":"_ceeed7","logo":"_c29e88","typography":"_cbbf89"};